import { TIME_TABLE_DETAILS, UPDATE_FIELDS } from "../../annotation/PlanningConstants";

export const setTrailPeriod = (from: Date | null, to: Date | null, dispatch: React.Dispatch<any>) => {
    if (!from || !to) return;

    // Reset times to midnight for accurate day difference
    const fromDate = new Date(from.getFullYear(), from.getMonth(), from.getDate());
    const toDate = new Date(to.getFullYear(), to.getMonth(), to.getDate());

    const diffMs = toDate.getTime() - fromDate.getTime();

    // Negative range: skip
    if (diffMs < 0) return;

    const diffInDays = diffMs / (1000 * 60 * 60 * 24); // Convert ms to days

    // Add 1 to include both the start and end dates in the total day count
    const totalDays = diffInDays + 1;

    let trialValue: string = "";

    // Determine trial period based on total number of days, inclusive of both dates
    if (totalDays >= 5) {
        trialValue = "3 days";
    } else if (totalDays >= 4) {
        trialValue = "2 days";
    } else if (totalDays >= 3) {
        trialValue = "1.5 days";
    } else if (totalDays >= 2) {
        trialValue = "1 day";
    } else if (totalDays >= 1) {
        trialValue = "3 hours";
    }

    dispatch({
        type: UPDATE_FIELDS,
        tab: TIME_TABLE_DETAILS,
        field: "trailPeriod",
        value: trialValue,
    });
}